import {
  AccordionDetails,
  Grid,
  Stack,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import useStaff from "../../../../Hooks/staff";
import { Formik } from "formik";

const OtherIntrestsInformation = () => {
  const { addStaffInterestInfo, staffPersonalInfo, addNewInterest } =
    useStaff();

  const defaultChecked = addNewInterest?.[0]?.type?.split(",").map((_el) => {
    return _el;
  });

  const [otherInterests, setOtherIntrests] = useState({
    id: "",
    idFaculty: "",
    type: "",
  });

  useEffect(() => {
    setOtherIntrests({
      id: addNewInterest?.[0]?.id ? addNewInterest?.[0]?.id : "",
      idFaculty: staffPersonalInfo?.id,
      type: defaultChecked,
    });
  }, [addNewInterest, staffPersonalInfo]);

  return (
    <Stack>
      <Formik
        initialValues={otherInterests}
        validateOnBlur={false}
        validateOnChange={false}
        enableReinitialize
        onSubmit={(values) => {
          addStaffInterestInfo(values);
        }}
      >
        {(formik) => {
          const { handleChange, handleSubmit, values } = formik;
          return (
            <form id="addStaffInterest" onSubmit={handleSubmit}>
              <AccordionDetails>
                <Grid container spacing={6}>
                  <Grid item md={4} sm={12}>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                      }}
                    >
                      <Stack>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="type"
                              value="Sports"
                              checked={values?.type?.includes("Sports")}
                              onChange={handleChange}
                            />
                          }
                          label="Sports"
                        />
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                      }}
                    >
                      <Stack>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="type"
                              value="Culturals"
                              checked={values?.type?.includes("Culturals")}
                              onChange={handleChange}
                            />
                          }
                          label="Culturals"
                        />
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                      }}
                    >
                      <Stack>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="type"
                              checked={values?.type?.includes("Doctorate")}
                              value="Doctorate"
                              onChange={handleChange}
                            />
                          }
                          label="Doctorate"
                        />
                      </Stack>
                    </Stack>
                  </Grid>
                  <Grid item md={4} sm={12}>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                      }}
                    >
                      <Stack>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="type"
                              checked={values?.type?.includes("Research")}
                              value="Research"
                              onChange={handleChange}
                            />
                          }
                          label="Research"
                        />
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                      }}
                    >
                      <Stack>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="type"
                              checked={values?.type?.includes("NCC")}
                              value="NCC"
                              onChange={handleChange}
                            />
                          }
                          label="NCC"
                        />
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                      }}
                    >
                      <Stack>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="type"
                              checked={values?.type?.includes(
                                "Event Management"
                              )}
                              value="Event Management"
                              onChange={handleChange}
                            />
                          }
                          label="Event Management"
                        />
                      </Stack>
                    </Stack>
                  </Grid>
                  <Grid item md={4} sm={12}>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                      }}
                    >
                      <Stack>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="type"
                              checked={values?.type?.includes("NSS")}
                              value="NSS"
                              onChange={handleChange}
                            />
                          }
                          label="NSS"
                        />
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                      }}
                    >
                      <Stack>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="type"
                              checked={values?.type?.includes("Seminars")}
                              value="Seminars"
                              onChange={handleChange}
                            />
                          }
                          label="Seminars"
                        />
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </form>
          );
        }}
      </Formik>
    </Stack>
  );
};

export default OtherIntrestsInformation;
